module.exports = __webpack_public_path__ + "static/media/3.dd79b313.jpeg";